export default __webpack_public_path__ + "febc2ed0d0230eb2c95c5f12d33f9b25.otf";